import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_97: FaireProductEntity = {
  token: "starter_collection_97",
  type: "product",
  name: "Le (Grand) Verre - Set of 4",
  brandName: "Sophie Lou Jacobsen",
  imageUrl:
    '"https://cdn.faire.com/fastly/e09088de357ab856555b931df1afa03a2eb97df936a903bc8c7a8f0a7b3f0c42.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=3256',
  priceDollars: 88,
  msrpDollars: 176,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
